import image from 'images/launching.jpg';

export const LaunchingPage = () => {
  return (
    <div className="LaunchingPage">
      <img src={image} alt="notice-image" style={{ width: "90%", paddingTop: "30px" }} />
    </div>
  );
};